/**
 * Is a player in the world right now? Read by the service-worker update handler in main.tsx so a
 * new deploy doesn't reload the page mid-fight. The game chunk installs the real probe when it
 * loads; until then (site, admin, account pages) nobody is mid-session. This keeps main.tsx from
 * importing the game store, which would pull game code into every page's entry bundle.
 */
let probe: () => boolean = () => false;

export function setInSessionProbe(fn: () => boolean): void {
  probe = fn;
}

export function inSession(): boolean {
  return probe();
}
